"use client";

import { useRef } from "react";
import useClickOutside from "../useClickOutside";
import useModal from "../useModal";

export type IModal = ReturnType<typeof useModal>;

export default function useSortModal() {
  const { isOpen, openModal, closeModal, toggleModal } = useModal(
    "sort-modal",
    () => {},
    true,
    false
  );

  const ref = useRef<HTMLDivElement>(null);
  useClickOutside(ref, closeModal);

  return {
    isOpen,
    openModal,
    closeModal,
    toggleModal,
    ref,
  };
}
